
    <ng-container *ngIf="useV3Messaging$ | async; else legacyMessaging">
      <!-- V3 Messaging Component -->
      <portal-dashboard-folders-v3></portal-dashboard-folders-v3>
    </ng-container>

    <ng-template #legacyMessaging>
      <!-- Legacy Messaging Component -->
      <portal-dashboard-folders></portal-dashboard-folders>
    </ng-template>
  